export enum SignupScenario {
  PATIENT_NEW = 'PATIENT_NEW',
  PATIENT_ONBOARD = 'PATIENT_ONBOARD',
  ADMIN_NEW = 'ADMIN_NEW',
  ADMIN_ADDITIONAL = 'ADMIN_ADDITIONAL',
  THERAPIST = 'THERAPIST',
  MANAGEMENT = 'MANAGEMENT',
  PREVENTION = 'PREVENTION',
}
